export default "__VITE_ASSET__DfY_gUSF__"